import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, ActionContext } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { RootState } from './types';
import { camera } from './modules/camera';
import color from './modules/color';
import completion from './modules/completion';
import { error } from './modules/error';
import { imageID } from './modules/image-id';
import { terms } from './modules/terms';
import { auth } from './modules/auth';
import { support } from './modules/support';
import { maintenance } from './modules/maintenance';
import { orientation } from './modules/orientation';
import { i18n } from './modules/i18n';

Vue.use(Vuex);

function createState(): RootState {
  const state: RootState = {} as RootState;
  clearState(state);
  return state;
}

function clearState(state: RootState): void {
  state.accessToken = '';
  state.kycRequestID = 0;
  state.motionDirection = '';
}

export const mutations: MutationTree<RootState> = {
  storeAccessToken(state, payload: string) {
    state.accessToken = payload;
  },

  storeKycRequestId(state, payload: number) {
    state.kycRequestID = payload;
  },

  storeMotionDirection(state, payload: string) {
    state.motionDirection = payload;
  },

  clearState(state: RootState) {
    clearState(state);
  }
};

export const actions: ActionTree<RootState, RootState> = {
  clearState(context: ActionContext<RootState, RootState>) {
    context.dispatch('camera/clearState');
    context.dispatch('color/clearState');
    context.dispatch('completion/clearState');
    context.dispatch('error/clearState');
    context.dispatch('imageID/clearState');
    context.dispatch('terms/clearState');
    context.dispatch('auth/clearState');
    context.dispatch('support/clearState');
    context.dispatch('maintenance/clearState');
    context.dispatch('orientation/clearState');
    context.dispatch('i18n/clearState');
    context.commit('clearState');
  }
};

export default new Vuex.Store<RootState>({
  state: createState,
  mutations,
  actions,
  modules: {
    camera,
    color,
    completion,
    error,
    imageID,
    terms,
    auth,
    support,
    maintenance,
    orientation,
    i18n
  },
  plugins: [
    createPersistedState({
      key: 'liquid-ekyc-applicant',
      reducer: (state: any): object => ({
        auth: state.auth,
        camera: {
          idDocType: state.camera.idDocType,
          mnDocType: state.camera.mnDocType,
          gpDocType: state.camera.gpDocType,
          opDocType: state.camera.opDocType,
          gpDocPageLast: state.camera.gpDocPageLast,
          opDocTermLast: state.camera.opDocTermLast,
          opDocPageLast: state.camera.opDocPageLast,
          isDetectableIdDoc: state.camera.isDetectableIdDoc,
          photoID: state.camera.photoID
        },
        color: state.color,
        completion: state.completion,
        i18n: { locale: state.i18n.locale }
      })
    })
  ]
});
